import { render } from "./ButiranKelahiran.vue?vue&type=template&id=10b2fe2e"
import script from "./ButiranKelahiran.vue?vue&type=script&lang=js"
export * from "./ButiranKelahiran.vue?vue&type=script&lang=js"

import "./ButiranKelahiran.vue?vue&type=style&index=0&id=10b2fe2e&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__